export default __webpack_public_path__ + "static/media/layer-1.51142a60.svg";